<script setup>
import { LazyPromoEditorModal } from '#components'

const props = defineProps({
  item: Object,
  recipeId: {
    type: Number,
    default: 0,
  },
  position: {
    type: Number,
    default: 0,
  },
  adminMode: {
    type: Boolean,
    default: false,
  },
})
const userStore = useUserStore()
const config = useRuntimeConfig()
const modalStore = useModalStore()
const overlay = useOverlayWithAd()
const router = useRouter()
const { localePath } = useI18n()

// Conditions
const hasCoupon = computed(() =>
  props.item.item_label.includes('coupon')
  || props.item.item_description.includes('coupon')
  || props.item.price_description.includes('coupon'),
)

const hasMembre = computed(() =>
  props.item.item_label.includes('membre')
  || props.item.item_description.includes('membre')
  || props.item.price_description.includes('membre'),
)

async function openItemModal(itemId) {
  if (props.adminMode) {
    const modal = overlay.create(LazyPromoEditorModal, {
      props: { itemId },
    })
    const modalInstance = modal.open()
    const _input = await modalInstance.result
  }
  else {
    modalStore.openItemModal(itemId)
  }
}

// Aller vers la circulaire
/* async function goToFlyer(item) {
  try {
    const response = await $fetch(`${config.public.apiUrl}/grocery-list/get-flyer-data`, {
      method: 'GET',
      query: { item_id: item.flyer_item_id },
      headers: {
        Authorization: `Bearer ${userStore.access_token}`,
      },
    })
    if (response.success === 1) {
      router.push(localePath({
        name: 'FlyerPage',
        params: {
          id: response.flyer_id,
          slug: response.slug,
        },
        query: {
          item_id: response.flyer_item_id,
        },
      }))
    }
    else if (response.success === 0) {
      // Handle error - could add toast notification here
      console.error(response.message)
    }
  }
  catch (err) {
    console.error('Error getting flyer data:', err)
  }
} */
</script>

<template>
  <li class="flex flex-col col-span-1 text-center bg-white rounded-lg shadow gap-2 py-2 h-full">
    <div class="flex-1 flex flex-col relative">
      <dd class="mx-auto h-10 p-1">
        <img class="bg-white h-6" :src="`${config.public.backendCdnUrl}/u/stores/${item.store_slug}.png`" alt="">
      </dd>
      <div class="relative w-6/10 lg:w-8/10 mx-auto shadow-xs rounded-lg border-1 border-poivre-200">
        <div v-if="item.ing_score !== 0" class=" opacity-90 rounded-full text-md cursor-pointer h-8 w-8 -top-4 -right-4 absolute text-center grid place-items-center" :style="`background-color:${item.colors.star_color};color:white`" @click="modalStore.openScoreHelpModal">
          <div class="font-medium inline-block align-middle">
            {{ item.ing_score }}
          </div>
        </div>
        <div class="p-1">
          <img class="w-full flex-shrink-0 mx-auto bg-black mt-1 cursor-pointer" :src="`${item.cdn_thumbnail_url}`" alt="" loading="lazy" @click="openItemModal(item.id)">
        </div>
        <button class="w-full bg-gradient-to-r from-tomate/10 to-sauge/10 hover:from-tomate/20 hover:to-sauge/20 border-t border-poivre-200 flex items-center text-poivre-600 justify-center gap-1.5 text-xs font-semibold py-1 transition-all duration-200 hover:shadow-sm" @click="openItemModal(item.id)">
          <UIcon name="i-mdi-eye-outline" class="text-sm" /> <span>Voir détails</span>
        </button>
      </div>

      <dl class="mt-1 flex-grow flex flex-col justify-between px-3">
        <dd class="flex justify-center">
          <div v-if="item.item_label.includes('coupon') || item.item_description.includes('coupon') || item.price_description.includes('coupon')" class="inline-flex px-2 py-1 rounded-full text-xs font-normal text-white items-center opacity-80" style="background-color:#37a4b0">
            <UIcon name="i-mdi-ticket-percent-outline" class="mr-1 text-sm" /> <span>Coupon requis</span>
          </div>
          <div v-if="item.item_label.includes('membre') || item.item_description.includes('membre') || item.price_description.includes('membre')" class="inline-flex px-2 py-1 rounded-full text-xs font-normal text-white items-center opacity-80" style="background-color:#7b37b0">
            <UIcon name="i-mdi-card-text-outline" class="mr-1 text-sm" /> <span>Prix membre</span>
          </div>
        </dd>
        <dd v-if="item._formatted" class="text-poivre-500 text-sm mt-2 font-medium" v-html="item._formatted.item_label" />
        <dd v-else class="text-poivre-500 text-sm mt-2 font-medium first-letter:uppercase">
          {{ item.item_label }}
        </dd>
        <dd v-if="item._formatted" class="text-poivre-400 text-xs mt-0 truncate" v-html="item._formatted.item_description" />
        <dd v-else class="text-poivre-400 text-xs mt-0 truncate first-letter:uppercase">
          {{ item.item_description }}
        </dd>
        <dd v-if="item.price !== 0.00" class="mt-2">
          <span class="px-2 py-1 font-bold first-letter:uppercase ">{{ item.price_text ?? item.price_description }}</span>
        </dd>
      </dl>
    </div>
    <div>
      <div class="pb-2 relative">
        <ShoppingListButton class="flex justify-center" :flyer-item="item" :recipe-id="recipeId" />

        <!-- DropdownMenu avec icône de 3 points en position absolue -->
        <UDropdownMenu
          :items="[
            {
              label: 'Afficher dans la circulaire',
              icon: 'material-symbols:eye-tracking-outline-sharp',
              onSelect: () => goToFlyer(item),
            },
          ]"
          :content="{ align: 'end', sideOffset: 1 }"
          class="absolute bottom-3 right-3"
        >
          <UButton
            color="neutral"
            variant="ghost"
            icon="i-mdi-dots-vertical"
            size="xs"
            class="hidden"
          />
        </UDropdownMenu>
      </div>
    </div>
  </li>
</template>
